import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    // API and axios are stable module-level constants — empty deps is correct
    // eslint-disable-next-line react-hooks/exhaustive-deps
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(res => setUser(res.data))
      .catch(() => setUser(null));
  }, []);

  // Stable function refs — setUser is guaranteed stable by React
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const login = useCallback(async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    setUser(res.data);
    return res.data;
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const logout = useCallback(async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    setUser(null);
  }, []);

  // Memoised value — prevents unnecessary re-renders of consuming components
  const value = useMemo(
    () => ({ user, login, logout, isLoading: user === undefined }),
    [user, login, logout]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
